'use strict';

module.exports = {
	flashInfo: function flashInfo(message) {
		return {
			type: 'FLASH_INFO',
			message: message
		};
	},

	flashError: function flashError(message) {
		return {
			type: 'FLASH_ERROR',
			message: message
		};
	},

	flashSuccess: function flashSuccess(message) {
		return {
			type: 'FLASH_SUCCESS',
			message: message
		};
	},

	showLoadingModal: function showLoadingModal() {
		return {
			type: 'SHOW_LOADING_MODAL'
		};
	},

	hideLoadingModal: function hideLoadingModal() {
		return {
			type: 'HIDE_LOADING_MODAL'
		};
	}
};


//////////////////
// WEBPACK FOOTER
// ./client/actions/dialogsActions.js
// module id = 21
// module chunks = 5